import React from 'react'
import { Switch, Route, NavLink } from 'react-router-dom'
import { Layout } from 'app/theme/layout'
import { useQuery } from 'jsonapi-react'
import styles from './AccountPage.module.css'
import Profile from './account/Profile'
import ChangePassword from './account/ChangePassword'
import { Helmet } from 'react-helmet'

export default function AccountPage({ session }) {
  return (
    <Layout className="container flex py-12 max-w-3xl">
      <Helmet>
        <title>My Account</title>
      </Helmet>
      <div className="hidden lg:block w-1/5 font-national">
        <nav className={styles.nav}>
          <NavLink exact to="/account">Profile</NavLink>
          <NavLink exact to="/account/change-password">Password</NavLink>
        </nav>
      </div>
      <div className="w-full lg:w-4/5 xl:w-5/6">
        <Switch>
          <Route exact path="/account">
            <Profile session={session} />
          </Route>
          <Route exact path="/account/change-password">
            <ChangePassword session={session} />
          </Route>
        </Switch>
      </div>
    </Layout>
  )
}
